module.exports = __webpack_public_path__ + "static/media/bmw_car_driving-license.9d698c5d.svg";